import { render } from "./EmployeeOrganogram.vue?vue&type=template&id=8f2f36ba&scoped=true"
import script from "./EmployeeOrganogram.vue?vue&type=script&lang=js"
export * from "./EmployeeOrganogram.vue?vue&type=script&lang=js"

import "./EmployeeOrganogram.vue?vue&type=style&index=0&id=8f2f36ba&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f2f36ba"]])

export default __exports__